import { GlobalErrorFallback } from '@a-type/ui';
export const commonRouterConfig = {
    scrollToTopSelectors: ['#page--main-content'],
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultErrorComponent: GlobalErrorFallback,
    defaultViewTransition: true,
};
//# sourceMappingURL=router.js.map